import { Injectable } from '@angular/core';
import { HttpClientService } from './httpClient.service';
import { Cidade } from '../model/cidade.model';
import { ResultCEP } from '../model/resultCEP.model';

import { map } from 'rxjs/operators';

@Injectable()
export class IbgeService {

  constructor(private http: HttpClientService) { }

  getCidades(uf) {
      return this.http.get<Cidade[]>(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/` + uf + `/municipios`).pipe(map(response => response)).pipe(map(response => response));
  }

  getCEP(cep) {
      return this.http.get<ResultCEP>(`https://viacep.com.br/ws/` + cep + `/json/`).pipe(map(response => response));
  }
}
